import { CreateStorageProxy } from "./code/LocalStorage";

const Plugin = {};
Plugin.install = function(Vue) {
  Vue.prototype.$storageWatch = Vue.observable({ lastOrder: undefined });
  Vue.prototype.$storage = CreateStorageProxy("rgpu", "0.0.1", Vue.prototype.$storageWatch);
};

export default Plugin;
